/**
 * Énumération des paramètres de configuration
 */
enum PARAMETRE {
  SIGNALEMENT_DELIBERATION_CORPS_EMAIL = "SIGNALEMENT_DELIBERATION_CORPS_EMAIL",
  SIGNALEMENT_DELIBERATION_DESTINATAIRE_EMAIL = "SIGNALEMENT_DELIBERATION_DESTINATAIRE_EMAIL",
  SIGNALEMENT_DELIBERATION_OBJET_EMAIL = "SIGNALEMENT_DELIBERATION_OBJET_EMAIL",
  AFFICHAGE_INDISPO = "AFFICHAGE_INDISPO",
  AFFICHAGE_SYMBOLES_NORMALISES = "AFFICHAGE_SYMBOLES_NORMALISES",
  ACCUEIL_PUBLIC = "ACCUEIL_PUBLIC",
  BAN_CODE_DEPARTEMENT = "BAN_CODE_DEPARTEMENT",
  BRIDAGE_PHOTO = "BRIDAGE_PHOTO",
  BUFFER_CARTE = "BUFFER_CARTE",
  CARACTERISTIQUE_PENA = "CARACTERISTIQUE_PENA",
  CARACTERISTIQUE_PIBI = "CARACTERISTIQUE_PIBI",
  CARACTERISTIQUES_PENA_TOOLTIP_WEB = "CARACTERISTIQUES_PENA_TOOLTIP_WEB",
  CARACTERISTIQUES_PIBI_TOOLTIP_WEB = "CARACTERISTIQUES_PIBI_TOOLTIP_WEB",
  COORDONNEES_FORMAT_AFFICHAGE = "COORDONNEES_FORMAT_AFFICHAGE",
  COURRIER_RESTRICTION_ZC = "COURRIER_RESTRICTION_ZC",
  CREATION_PEI_MOBILE = "CREATION_PEI_MOBILE",
  DECI_DISTANCE_MAX_PARCOURS = "DECI_DISTANCE_MAX_PARCOURS",
  DECI_ISODISTANCES = "DECI_ISODISTANCES",
  DECLARATION_PEI_DESTINATAIRE_EMAIL = "DECLARATION_PEI_DESTINATAIRE_EMAIL",
  DECLARATION_PEI_OBJET_EMAIL = "DECLARATION_PEI_OBJET_EMAIL",
  DECLARATION_PEI_CORPS_EMAIL = "DECLARATION_PEI_CORPS_EMAIL",
  DFCI_TRAVAUX_DESTINATAIRE_EMAIL = "DFCI_TRAVAUX_DESTINATAIRE_EMAIL",
  DFCI_TRAVAUX_OBJET_EMAIL = "DFCI_TRAVAUX_OBJET_EMAIL",
  DFCI_TRAVAUX_CORPS_EMAIL = "DFCI_TRAVAUX_CORPS_EMAIL",
  DFCI_TOLERANCE_DFCI_PISTE_METRES = "DFCI_TOLERANCE_DFCI_PISTE_METRES",
  DFCI_LISTE_COUCHE = "DFCI_LISTE_COUCHE",
  DUREE_VALIDITE_TOKEN = "DUREE_VALIDITE_TOKEN",
  EMPRISE_NATIVE = "EMPRISE_NATIVE",
  GESTION_AGENT = "GESTION_AGENT",
  MDP_ADMINISTRATEUR = "MDP_ADMINISTRATEUR",
  MENTION_CNIL = "MENTION_CNIL",
  MESSAGE_ENTETE = "MESSAGE_ENTETE",
  MODE_DECONNECTE = "MODE_DECONNECTE",
  PEI_COLONNES = "PEI_COLONNES",
  PEI_DELAI_CTRL_URGENT = "PEI_DELAI_CTRL_URGENT",
  PEI_DELAI_CTRL_WARN = "PEI_DELAI_CTRL_WARN",
  PEI_DELAI_RECO_URGENT = "PEI_DELAI_RECO_URGENT",
  PEI_DELAI_RECO_WARN = "PEI_DELAI_RECO_WARN",
  PEI_DEPLACEMENT_DIST_WARN = "PEI_DEPLACEMENT_DIST_WARN",
  PEI_GENERATION_CARTE_TOURNEE = "PEI_GENERATION_CARTE_TOURNEE",
  PEI_HIGHLIGHT_DUREE = "PEI_HIGHLIGHT_DUREE",
  PEI_HIGHLIGHT_COULEUR = "PEI_HIGHLIGHT_COULEUR",
  PEI_HIGHLIGHT_RAYON = "PEI_HIGHLIGHT_RAYON",
  PEI_HIGHLIGHT_LARGEUR = "PEI_HIGHLIGHT_LARGEUR",
  PEI_SELECTION_COULEUR = "PEI_SELECTION_COULEUR",
  PEI_SELECTION_RAYON = "PEI_SELECTION_RAYON",
  PEI_SELECTION_LARGEUR = "PEI_SELECTION_LARGEUR",
  PEI_METHODE_TRI_ALPHANUMERIQUE = "PEI_METHODE_TRI_ALPHANUMERIQUE",
  PEI_NOMBRE_HISTORIQUE = "PEI_NOMBRE_HISTORIQUE",
  PEI_ROUTE_HISTORIQUE = "PEI_ROUTE_HISTORIQUE",
  PEI_RENOUVELLEMENT_CTRL_PRIVE = "PEI_RENOUVELLEMENT_CTRL_PRIVE",
  PEI_RENOUVELLEMENT_CTRL_PUBLIC = "PEI_RENOUVELLEMENT_CTRL_PUBLIC",
  PEI_RENOUVELLEMENT_CTRL_ICPE = "PEI_RENOUVELLEMENT_CTRL_ICPE",
  PEI_RENOUVELLEMENT_CTRL_ICPE_CONVENTIONNE = "PEI_RENOUVELLEMENT_CTRL_ICPE_CONVENTIONNE",
  PEI_RENOUVELLEMENT_CTRL_CONVENTIONNE = "PEI_RENOUVELLEMENT_CTRL_CONVENTIONNE",
  PEI_RENOUVELLEMENT_RECO_PRIVE = "PEI_RENOUVELLEMENT_RECO_PRIVE",
  PEI_RENOUVELLEMENT_RECO_PUBLIC = "PEI_RENOUVELLEMENT_RECO_PUBLIC",
  PEI_RENOUVELLEMENT_RECO_ICPE = "PEI_RENOUVELLEMENT_RECO_ICPE",
  PEI_RENOUVELLEMENT_RECO_ICPE_CONVENTIONNE = "PEI_RENOUVELLEMENT_RECO_ICPE_CONVENTIONNE",
  PEI_RENOUVELLEMENT_RECO_CONVENTIONNE = "PEI_RENOUVELLEMENT_RECO_CONVENTIONNE",
  PEI_RENUMEROTATION_INTERNE_AUTO = "PEI_RENUMEROTATION_INTERNE_AUTO",
  PEI_TOLERANCE_COMMUNE_METRES = "PEI_TOLERANCE_COMMUNE_METRES",
  PEI_FICHE_RESUME_STANDALONE = "PEI_FICHE_RESUME_STANDALONE",
  PEI_DISPLAY_IDENTIFIANT_GESTIONNAIRE = "PEI_DISPLAY_IDENTIFIANT_GESTIONNAIRE",
  PEI_DISPLAY_TYPE_ENGIN = "PEI_DISPLAY_TYPE_ENGIN",
  PEI_LIBELLE_NON_CONFORME = "PEI_LIBELLE_NON_CONFORME",
  PERMIS_TOLERANCE_CHARGEMENT_METRES = "PERMIS_TOLERANCE_CHARGEMENT_METRES",
  PROFONDEUR_COUVERTURE = "PROFONDEUR_COUVERTURE",
  RECEPTION_RECO_INIT_OBLIGATOIRE = "RECEPTION_RECO_INIT_OBLIGATOIRE",
  VALEUR_HAUTE_MINIMALE_HISTOGRAMME = "VALEUR_HAUTE_MINIMALE_HISTOGRAMME",
  TITRE_PAGE = "TITRE_PAGE",
  TOLERANCE_VOIES_METRES = "TOLERANCE_VOIES_METRES",
  TYPE_VISITE_CDP = "TYPE_VISITE_CDP",
  VITESSE_EAU = "VITESSE_EAU",
  VOIE_SAISIE_LIBRE = "VOIE_SAISIE_LIBRE",
  ORGANISME_DEFAUT = "ORGANISME_DEFAUT",
  PROFIL_UTILISATEUR_DEFAUT = "PROFIL_UTILISATEUR_DEFAUT",
  CONSERVER_OBSERVATION_VISITE = "CONSERVER_OBSERVATION_VISITE",
  RECHERCHE_BAN = "RECHERCHE_BAN",
}
export default PARAMETRE;
